import { render, staticRenderFns } from "./ModalBroadcastCandidate.vue?vue&type=template&id=3aa2d5b5&"
import script from "./ModalBroadcastCandidate.vue?vue&type=script&lang=ts&"
export * from "./ModalBroadcastCandidate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports